import React from 'react'

import '../assets/css/card.css'
function PortfolioCard({Cardtitle , Carddesc ,url , CardImg}) {
  return (
    <div className='portcard'>
        <img src={CardImg} alt="" />
        <h4>{Cardtitle}</h4>
        <p>{Carddesc}</p>
        <button>
           <a href={url} target="_blank" >
            View Project
           </a>
        </button>

    </div>
  )
}

export default PortfolioCard
